
import { VBanner } from "vuetify/lib";

export default VBanner.extend({});
